export default __webpack_public_path__ + "static/media/stuck-veskovic-poolbau-3.5c5fa78e.jpg";